export default function Datenschutz() {
    return (
        <div data-testid="page-datenschutz" className="pt-16 md:pt-24 pb-24">
            <div className="max-w-[900px] mx-auto px-6 md:px-12 lg:px-16">
                <p className="overline mb-6">Rechtliches</p>
                <h1 className="font-display text-5xl sm:text-6xl tracking-tighter leading-[0.95] font-medium text-ink mb-12">
                    Datenschutz­erklärung
                </h1>

                <div className="font-body text-[15px] leading-relaxed text-ink space-y-8">
                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">1. Verantwortliche Stelle</h2>
                        <p>
                            Mein Schuster · Schuh- und Schlüsseldienst<br/>
                            Weichser Weg 5, 93059 Regensburg<br/>
                            Telefon: +49 941 4610027<br/>
                            E-Mail: agisschluesseldienst@gmail.com
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">2. Allgemeines</h2>
                        <p>
                            Wir freuen uns über Ihren Besuch auf unserer Webseite. Der Schutz
                            Ihrer Daten ist uns wichtig. In dieser Datenschutzerklärung
                            informieren wir Sie über Art, Umfang und Zwecke der Erhebung und
                            Verwendung personenbezogener Daten.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">3. Server-Logfiles</h2>
                        <p>
                            Beim Aufruf unserer Webseite werden durch unseren Hosting-Provider
                            automatisch Daten in Logfiles gespeichert (Browsertyp, Betriebssystem,
                            Datum und Uhrzeit, anonymisierte IP-Adresse, Referrer-URL).
                            Eine Zusammenführung dieser Daten mit anderen Datenquellen wird
                            nicht vorgenommen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO
                            (berechtigtes Interesse an einem sicheren Betrieb).
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">4. Kontaktaufnahme</h2>
                        <p>
                            Wenn Sie uns per Kontaktformular, E-Mail, Telefon oder WhatsApp
                            kontaktieren, werden Ihre Angaben (Name, Kontaktdaten,
                            Nachrichtinhalt) zum Zwecke der Bearbeitung verarbeitet.
                            Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO. Die Daten werden
                            gelöscht, sobald sie für den Zweck der Bearbeitung nicht mehr
                            erforderlich sind, soweit keine gesetzlichen
                            Aufbewahrungs­pflichten entgegenstehen.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">5. Eingebundene Dienste</h2>
                        <p>
                            <strong>Google Maps:</strong> Auf der Kontakt-Seite betten wir
                            Google Maps zur Anzeige des Standorts ein. Beim Aufruf werden Daten
                            an Google LLC (USA) übermittelt. Mehr Infos:&nbsp;
                            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">
                                policies.google.com/privacy
                            </a>.
                        </p>
                        <p className="mt-3">
                            <strong>Google Fonts:</strong> Wir nutzen Schriftarten von Google
                            Fonts. Beim Seitenaufruf wird die Schrift von Google-Servern geladen.
                        </p>
                        <p className="mt-3">
                            <strong>WhatsApp / Telefon-Links:</strong> Bei Klick auf den
                            WhatsApp- oder Telefon-Button werden Sie an die jeweilige App
                            weitergeleitet. Es gelten dann die Datenschutzbestimmungen des
                            Anbieters.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">6. Ihre Rechte</h2>
                        <p>
                            Sie haben jederzeit das Recht auf Auskunft (Art. 15 DSGVO),
                            Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der
                            Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch
                            (Art. 21). Ferner haben Sie ein Beschwerderecht bei der zuständigen
                            Aufsichtsbehörde (Art. 77 DSGVO). Für Bayern ist dies das
                            Bayerische Landesamt für Datenschutzaufsicht (BayLDA).
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">7. SSL-Verschlüsselung</h2>
                        <p>
                            Diese Seite nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung.
                            Eine verschlüsselte Verbindung erkennen Sie am „https://" in der
                            Adresszeile Ihres Browsers.
                        </p>
                    </section>

                    <p className="text-xs text-inkSoft pt-8 border-t border-line">
                        Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}.
                        Diese Datenschutzerklärung ist ein Muster-Entwurf und sollte vor der
                        Veröffentlichung durch einen Datenschutzbeauftragten oder Anwalt
                        überprüft werden.
                    </p>
                </div>
            </div>
        </div>
    );
}
